/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema } from '@gh/builder-shared';
import { FormState, FormStateSchema, whenCreateOrEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { LetterTemplateAvailability } from '../../resources/job-letters.model';

@Injectable()
export class JobLetterListTabFormState extends FormState<LetterTemplateAvailability> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  protected buildSchema(jobLetters: LetterTemplateAvailability,
                        { root, group, array }: FormStateSchema): FormRootSchema {
    return root({
      mode: FormMode.EditMode,
      enabled: whenCreateOrEditMode(),
      children: {
        list: array({
          children: (jobLetters.list || []).map((letter) => group({
            key: letter.fileName,
            children: {
              fileName: void 0,
              isAvailable: void 0,
            },
          })),
        }),
        version: void 0,
      },
    });
  }
}
